module.exports = __webpack_public_path__ + "static/media/mgalleryfour.b3ae2db3.jpg";